import {
  getCashiersWithPending,
  getCashierPending,
  bulkApproveCashier,
  getAllCashiers,
  getCashierAll,
} from "@/libs/api/cashierInvoices";

export default {
  namespaced: true,
  state: {
    cashiersWithPending: [],
    cashierPendingInvoices: [],
    allCashiers: [],
    cashierAllInvoices: [],
    pagination: {
      page: 1,
      pageSize: 25,
      total: 0,
    },
    loading: false,
    bulkApproveResult: null,
  },
  getters: {
    cashiersWithPending: (state) => state.cashiersWithPending,
    cashierPendingInvoices: (state) => state.cashierPendingInvoices,
    allCashiers: (state) => state.allCashiers,
    cashierAllInvoices: (state) => state.cashierAllInvoices,
    pagination: (state) => state.pagination,
    loading: (state) => state.loading,
    bulkApproveResult: (state) => state.bulkApproveResult,
  },
  actions: {
    async fetchCashiersWithPending({ commit }, params = {}) {
      commit("SET_LOADING", true);
      try {
        const response = await getCashiersWithPending(params);
        commit("SET_CASHIERS_WITH_PENDING", response.data.data || []);
        if (response.data.meta) {
          commit("SET_PAGINATION", response.data.meta);
        }
        return response;
      } catch (error) {
        commit("SET_LOADING", false);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchCashierPending({ commit }, { cashierId, params = {} }) {
      commit("SET_LOADING", true);
      try {
        const response = await getCashierPending(cashierId, params);
        commit("SET_CASHIER_PENDING_INVOICES", response.data.data || []);
        if (response.data.meta) {
          commit("SET_PAGINATION", response.data.meta);
        }
        return response;
      } catch (error) {
        commit("SET_LOADING", false);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async approveCashierBulk({ commit }, { cashierId, payload = {} }) {
      commit("SET_LOADING", true);
      try {
        const response = await bulkApproveCashier(cashierId, payload);
        commit("SET_BULK_APPROVE_RESULT", response.data);
        return response;
      } catch (error) {
        commit("SET_LOADING", false);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchAllCashiers({ commit }, params = {}) {
      commit("SET_LOADING", true);
      try {
        const response = await getAllCashiers(params);
        commit("SET_ALL_CASHIERS", response.data.data || []);
        if (response.data.meta) {
          commit("SET_PAGINATION", response.data.meta);
        }
        return response;
      } catch (error) {
        commit("SET_LOADING", false);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },

    async fetchCashierAll({ commit }, { cashierId, params = {} }) {
      commit("SET_LOADING", true);
      try {
        const response = await getCashierAll(cashierId, params);
        commit("SET_CASHIER_ALL_INVOICES", response.data.data || []);
        if (response.data.meta) {
          commit("SET_PAGINATION", response.data.meta);
        }
        return response;
      } catch (error) {
        commit("SET_LOADING", false);
        throw error;
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
  mutations: {
    SET_CASHIERS_WITH_PENDING(state, data) {
      state.cashiersWithPending = data;
    },
    SET_CASHIER_PENDING_INVOICES(state, data) {
      state.cashierPendingInvoices = data;
    },
    SET_ALL_CASHIERS(state, data) {
      state.allCashiers = data;
    },
    SET_CASHIER_ALL_INVOICES(state, data) {
      state.cashierAllInvoices = data;
    },
    SET_PAGINATION(state, meta) {
      state.pagination = {
        page: meta.page || 1,
        pageSize: meta.pageSize || 25,
        total: meta.total || 0,
      };
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_BULK_APPROVE_RESULT(state, result) {
      state.bulkApproveResult = result;
    },
    CLEAR_CASHIER_PENDING(state) {
      state.cashierPendingInvoices = [];
    },
    CLEAR_CASHIER_ALL(state) {
      state.cashierAllInvoices = [];
    },
  },
};
